import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  Legend, ResponsiveContainer
} from 'recharts';
import { colors } from '../../brand-colors';

/**
 * List Size Chart - Bar showing Email subscribers vs Purchases over time
 */
function ListSizeChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div style={styles.placeholder}>
        <p>No list data available</p>
        <small>Connect GHL to track list growth</small>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="date"
          tick={{ fill: colors.grey, fontSize: 11 }}
        />
        <YAxis
          yAxisId="left"
          tick={{ fill: colors.grey, fontSize: 12 }}
          label={{
            value: 'List Size',
            angle: -90,
            position: 'insideLeft',
            fill: colors.grey,
            fontSize: 11
          }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          tick={{ fill: colors.grey, fontSize: 12 }}
          label={{
            value: 'Purchases',
            angle: 90,
            position: 'insideRight',
            fill: colors.grey,
            fontSize: 11
          }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            color: colors.greyDarkest
          }}
        />
        <Legend />
        <Bar
          yAxisId="left"
          dataKey="email"
          name="Email List"
          fill={colors.teal}
        />
        <Bar
          yAxisId="right"
          dataKey="purchases"
          name="Purchases"
          fill={colors.tealDark}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

const styles = {
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center'
  }
};

export default ListSizeChart;
